var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16671 1.32373V3.73321C7.16671 4.05991 7.16671 4.22326 7.23029 4.34804C7.28621 4.4578 7.37545 4.54704 7.48521 4.60297C7.60999 4.66655 7.77334 4.66655 8.10004 4.66655H10.5095M8.33337 7.58317H3.66671M8.33337 9.9165H3.66671M4.83337 5.24984H3.66671M7.16671 1.1665H4.13337C3.15328 1.1665 2.66324 1.1665 2.28889 1.35724C1.95961 1.52502 1.69189 1.79274 1.52411 2.12202C1.33337 2.49637 1.33337 2.98641 1.33337 3.9665V10.0332C1.33337 11.0133 1.33337 11.5033 1.52411 11.8777C1.69189 12.2069 1.95961 12.4747 2.28889 12.6424C2.66324 12.8332 3.15328 12.8332 4.13337 12.8332H7.86671C8.8468 12.8332 9.33685 12.8332 9.71119 12.6424C10.0405 12.4747 10.3082 12.2069 10.476 11.8777C10.6667 11.5033 10.6667 11.0133 10.6667 10.0332V4.6665L7.16671 1.1665Z",
    stroke: "#0D3355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.53a4eadb.svg";
export { ForwardRef as ReactComponent };